<template>
    <v-card elevation="0" class="scroll" :height="winsize.height - 145">
        <utils-popup-input-text ref="utils-popup-input-text"></utils-popup-input-text>
        <utils-popup-select-character ref="utils-popup-select-character"></utils-popup-select-character>
        <utils-popup-select-emotion ref="utils-popup-select-emotion"></utils-popup-select-emotion>
        <v-card-actions class="ma-0 pa-0">
            <v-card elevation="0" outlined width="100%">
                <v-card-actions class="ma-2 pa-0">
                    <v-card outlined elevation="0" width="100%" class="pa-2 text-pre-wrap">
                        <h4>{{talkMessage == "" ? 'Talk message' : talkMessage}}</h4>
                    </v-card>
                </v-card-actions>
                <v-card-actions class="ma-0 pa-0 mt-7">
                    <v-btn class="green white--text ml-2 mr-2 mt-n5 mb-2 pr-5" elevation="0" @click="addText();"><v-icon class="mr-2">mdi-plus</v-icon>Add Existing Talk</v-btn>
                    <v-btn class="orange white--text ml-0 mr-5 mt-n5 mb-2 pr-5" elevation="0" @click="addEmpty();"><v-icon class="mr-2">mdi-folder-plus-outline</v-icon>New Talk</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="blue white--text ml-2 mr-2 mt-n5 mb-2" elevation="0" @click="copyToClipboard"><v-icon class="mr-2">mdi-clipboard-check-outline</v-icon>Copy to Clipboard (for tools)</v-btn>
<!--                    <v-btn class="orange white&#45;&#45;text ml-2 mr-2 mt-n5 mb-2" elevation="0" @click="onPressTransferTalks">Transfer Talks</v-btn>-->
<!--                    <v-btn class="pink white&#45;&#45;text ml-2 mr-2 mt-n5 mb-2" elevation="0" @click="onPressTransferPrompts">Transfer Prompts</v-btn>-->
                </v-card-actions>
            </v-card>
        </v-card-actions>
        <v-card v-for="phrase in this.phrases" :key="phrase.hash" class="ma-0 pa-0" elevation="0">
            <v-card-actions class="ma-0 pa-0 mt-1">
                <v-card elevation="0" outlined width="100%">
                    <v-card-actions class="ma-0 pa-2">
                        <v-btn elevation="0" @click="onPressAdd(phrase, true)">Add upper<v-icon color="green">mdi-chevron-up</v-icon></v-btn>
                        <v-btn elevation="0" @click="onPressAdd(phrase, false)">Add under<v-icon color="green">mdi-chevron-down</v-icon></v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="orange white--text" elevation="0" @click="onPressSelectCharacter(phrase)"><v-icon>mdi-account-sync-outline</v-icon></v-btn>
                        <v-btn class="blue white--text" elevation="0" @click="onPressSelectEmotion(phrase)"><v-icon>mdi-emoticon-happy-outline</v-icon></v-btn>
                        <v-btn outlined :class="phrase.place == 0 ? 'green white--text' : ' grey--text'" elevation="0" @click="onUpdatePlace(phrase, 0)"><v-icon>mdi-format-align-left</v-icon></v-btn>
                        <v-btn outlined :class="phrase.place == 1 ? 'green white--text' : ' grey--text'" elevation="0" @click="onUpdatePlace(phrase, 1)"><v-icon>mdi-format-align-right</v-icon></v-btn>
                        <v-card elevation="0" outlined class="ml-2">
                            <v-btn elevation="0" class="darken-1 white" @click="onUpdateSkip(phrase)"><v-icon class="mr-1">{{phrase.skip == 0 ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-intermediate'}}</v-icon>Skip</v-btn>
                        </v-card>
                        <v-spacer></v-spacer>
                        <v-btn icon elevation="0" @click="onPressDelete(phrase)"><v-icon color="red">mdi-delete</v-icon></v-btn>
                    </v-card-actions>
                    <v-card-actions class="ma-0 pa-3">
                        <v-spacer v-show="phrase.place == 1"></v-spacer>
                        <v-card elevation="0">
                            <v-card-actions class="ma-0 pa-0">
                                <v-card  width="200px" height="200px" elevation="0">
                                    <v-progress-circular v-if="getUrl(phrase) == undefined"
                                            style="margin-top: 85px; margin-left: 85px"
                                            indeterminate
                                            color="orange"
                                    ></v-progress-circular>
                                    <v-img v-else max-width="200"
                                           :style="{'transform': 'scaleX('+(phrase.place == 0 ? 1 : -1)+')'}"
                                           :src="getUrl(phrase)">
                                    </v-img>
                                </v-card>
                            </v-card-actions>
                            <v-card-actions class="ma-0 pa-0 mt-n2">
                                <v-card elevation="0" class="pa-1 text-center white--text" color="orange" width="100%">
                                    {{getHeroName(phrase.code)}}
                                </v-card>
                            </v-card-actions>
                        </v-card>
                    </v-card-actions>
                    <v-card-actions class="ma-0 pa-0 ml-2 mr-2 mb-2">
                        <v-card elevation="0" color="orange lighten-4" class="pa-3 text-center" width="100%">
                            <v-btn icon elevation="0" @click="onPressEditText(phrase)"><v-icon>mdi-pencil-outline</v-icon></v-btn>
                            {{phrase.text}}
                        </v-card>
                    </v-card-actions>
                    <v-card-actions v-if="phrase.skip != 0" class="ma-3 pa-0">
                        <v-spacer></v-spacer>
                        <v-btn elevation="0" class="white--text" color="blue">Skip</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>

import enJson from '@/modules/muiutils/resources/en.json'
import promptsJson from '@/modules/muiutils/resources/prompts.json';
import {HeroKind} from "@/modules/redactor/models/hero/HeroKind";
import firebase from "firebase";
import UtilsPopupInputText from "@/modules/muiutils/popups/utils-popup-input-text";
import UtilsPopupSelectCharacter from "@/modules/muiutils/popups/utils-popup-select-character";
import UtilsPopupSelectEmotion from "@/modules/muiutils/popups/utils-popup-select-emotion";

export default {
    name: "utils-talks-page",
    components: {UtilsPopupSelectEmotion, UtilsPopupSelectCharacter, UtilsPopupInputText},
    data: () => ({
        talkMessage: "",
        phrases:[],
        imagesUrls:{}
    }),
    mounted() {
        this.talkMessage = "";

        // debug
        // {
        //     this.talkMessage = "Ah yes, more Stardust. The magic of the Moon and the Sun will help us restore the land! Let me teach you! #{9:0:0;0;0}"
        //     var parce = this.parseText(this.talkMessage);
        //     if (!parce){
        //         this.$notify({title: 'Wrong text!', type: "error"});
        //         return;
        //     }
        //     this.talkMessage = this.getText(true);
        // }

    },
    computed:{
        winsize() {
            return window.app.winsize;
        }
    },
    methods: {
        addEmpty(){
            this.phrases = [];
            this.parseText("Empty Message#{1:0:0;0;0}");
            this.talkMessage = this.getText(true);
        },
        onPressSelectEmotion(phrase){
            var self = this;
            this.$refs['utils-popup-select-emotion'].show(phrase.code, phrase.emo,function (emotion) {
                for (var i in self.phrases) {
                    if (self.phrases[i].hash == phrase.hash) {
                        self.phrases[i].emo = emotion
                        self.getImage(self.phrases[i]);
                        self.talkMessage = self.getText(true);
                        return;
                    }
                }
            })
        },
        onPressSelectCharacter(phrase){
            var self = this;
            this.$refs['utils-popup-select-character'].show(phrase.code,function (code) {
                for (var i in self.phrases) {
                    if (self.phrases[i].hash == phrase.hash) {
                        self.phrases[i].code = code
                        self.getImage(self.phrases[i]);
                        self.talkMessage = self.getText(true);
                        return;
                    }
                }
            })
        },
        onPressAdd(phrase, up){
            this.$confirm("Are you sure?").then(() => {
                for (var i in this.phrases) {
                    if (this.phrases[i].hash == phrase.hash) {

                        var obj = {
                            "code": 1,
                            "emo": 0,
                            "place": 0,
                            "delay": 0,
                            "skip": 0,
                            "text": "Message Text",
                            "hash": (Math.random() + 1).toString(36).substring(2)
                        };

                        this.getImage(obj);

                        if (up){
                            this.phrases.splice(i, 0, obj)
                        }else{
                            this.phrases.splice(i + 1, 0, obj);
                        }

                        this.talkMessage = this.getText(true);
                        return;
                    }
                }
            }).catch(() => {})
        },
        onPressDelete(phrase){
            this.$confirm("Are you sure?").then(() => {
                for (var i in this.phrases) {
                    if (this.phrases[i].hash == phrase.hash) {
                        this.phrases.splice(i, 1);
                        this.talkMessage = this.getText(true);
                        return;
                    }
                }
            }).catch(() => {})
        },
        addText(){
            var self = this;
            this.$refs['utils-popup-input-text'].show("",function (text) {
                if (text.length == 0){
                    self.$notify({title: 'Empty text!', type: "error"});
                    return;
                }
                var parce = self.parseText(text);
                if (!parce){
                    self.$notify({title: 'Wrong text!', type: "error"});
                    return;
                }
                self.talkMessage = self.getText(true);
            })
        },
        copyToClipboard(){
            if (this.phrases.length == 0){
                this.parseText();
            }
            var text = this.getText(false);
            if (text.length == 0){
                this.$notify({title: 'Empty text!', type: "error"});
                return;
            }
            try {
                navigator.clipboard.writeText(text);
                this.$notify({title: 'Successfully Copied!', type: "succes"});
            } catch($e) {
                this.$notify({title: 'Fails Copied!', type: "error"});
            }
        },
        getText(formated){
            var text = "";
            for (var i in this.phrases){
                var obj = this.phrases[i];

                var message = obj.text;
                if (message[0] == " ") {
                    message = message.substring(1);
                }
                if (formated) {
                    text += "•    ";
                }
                text += message;
                text += "#{";
                text += obj.code + ":";
                text += obj.emo + ":";
                text += obj.place;
                text += ";";
                text += 0;// delay
                text += ";";
                text += obj.skip == 0 ? "0" : "1";
                text += "}";
                if (this.phrases.length - 1 != i) {
                    if (formated){
                        text += "\n";
                    }else{
                        text += " | ";
                    }
                }
            }
            return text;
        },
        onPressEditText(phrase){
            var oldValue = "";
            for (var i in this.phrases){
                if (this.phrases[i].hash == phrase.hash){
                    oldValue = this.phrases[i].text;
                }
            }
            var self = this;
            this.$refs['utils-popup-input-text'].show(oldValue, function (text) {
                for (var i in self.phrases){
                    if (self.phrases[i].hash == phrase.hash){
                        self.phrases[i].text = text;
                        self.talkMessage = self.getText(true);
                        return;
                    }
                }
            })
        },
        onUpdatePlace(phrase, place){
            for (var i in this.phrases){
                if (this.phrases[i].hash == phrase.hash){
                    this.phrases[i].place = place;
                }
            }
            this.talkMessage = this.getText(true);
        },
        onUpdateSkip(phrase){
            for (var i in this.phrases){
                if (this.phrases[i].hash == phrase.hash){
                    this.phrases[i].skip = !this.phrases[i].skip;
                }
            }
            this.talkMessage = this.getText(true);
        },
        getUrl(phrase){
            return this.imagesUrls[phrase.code + '*' + phrase.emo]
        },
        getImage(phrase){
            var key = phrase.code + '*' + phrase.emo;
            firebase.storage()
            .ref('assets/ch/'+this.getHeroKey(phrase.code)+'_'+phrase.emo+'.png')
            .getDownloadURL().then((url) => {
                this.imagesUrls[key] = url;
                this.$forceUpdate();
            }).catch(() => {
                this.imagesUrls[key] = require("@/modules/muiutils/resources/no-image-icon.png");
                this.$forceUpdate();
            });
        },
        getHeroName(code){
            let key = this.getHeroKey(code);
            return enJson[key] || key;
        },
        getHeroKey(code){
            const hero = HeroKind.getValueByCode(code);
            if (hero) {
                return hero.key;
            }
            return "none";
        },
        parseText(input) {
            this.phrases = [];
            var talks = input.split("|");
            for (var i in talks) {
                var tmp = talks[i].split("#");
                if (tmp.length == 2) {

                    var data = tmp[1];
                    data = data.replace("{", "");
                    data = data.replace("}", "");
                    data = data.replace(/\s/g, "");

                    var propertys = data.split(";");

                    var ch_pr = propertys[0]; // id:emojy:place
                    var delay_pr = propertys[1];
                    delay_pr = 0;
                    var skip_pr = propertys[2];

                    var ch_data = ch_pr.split(":");

                    var obj = {
                        "code": parseInt(ch_data[0]),
                        "emo": parseInt(ch_data[1]),
                        "place": parseInt(ch_data[2]),
                        "delay": Number(delay_pr),
                        "skip": parseInt(skip_pr),
                        "text": tmp[0],
                        "hash": (Math.random() + 1).toString(36).substring(2)
                    };

                    this.getImage(obj);
                    this.phrases.push(obj)
                }else{
                    return false;
                }
            }
            return true;
        },
        getLocalization(key) {
            return enJson[key]
        },
        onPressTransferPrompts() {

            var copy = JSON.parse(JSON.stringify(enJson));

            for (var i in promptsJson) {

                var key = promptsJson[i]["key"];
                var hero = promptsJson[i]["hero"];
                var heroKey = HeroKind.getValue(hero);

                if (!heroKey) {
                    console.error("NOT EXIST: ", hero);
                    return;
                }

                var localizationMessage = this.getLocalization(key + "_notify");
                if (localizationMessage != undefined) {
                    if (localizationMessage.length != 0) {
                        var updated = {};
                        updated[key] = [];
                        updated[key].push(heroKey.code)
                        updated[key].push(localizationMessage)
                    }else {
                        console.error(key, "EMPTY VALUE")
                    }
                } else {
                    console.error(i, key, "UNDEFINED")
                }

                for (var u in updated) {

                    var text = "";
                    var message = updated[u][1];
                    if (message[0] == " ") {
                        message = message.substring(1);
                    }
                    text += message;// message
                    text += "#{";
                    text += updated[u][0];// id
                    text += "}";

                    copy[u + "_notify"] = text;
                }
            }

            console.log(JSON.stringify(copy));
        },
    }

}
</script>


<style scoped>
.scroll {
    overflow-y: scroll
}
</style>